import PropTypes from 'prop-types';
import React from 'react';
import { formatAsNumber } from '../../../shared/util/transform';
import LabelComponent from './Label';
import './Total.styles.css';

const Total = React.memo(({ prefix, shown, object, size, type, filter, filterPrefix }) => (
  <aside className="total">
    {prefix} <em>{formatAsNumber(shown)}</em> {object} <em>{formatAsNumber(size)}</em> {type}
    {filter && (
      <>
        {filterPrefix}
        <LabelComponent
          name={filter}
          toolTip={`Remove filter ${filter}`}
          icon="icon-delete-1"
          type="info"
          clickId="removeFilter"
        />
      </>
    )}
  </aside>
));

Total.propTypes = {
  prefix: PropTypes.string,
  shown: PropTypes.number,
  object: PropTypes.string,
  size: PropTypes.number,
  type: PropTypes.string,
  filter: PropTypes.string,
  filterPrefix: PropTypes.string
};

Total.defaultProps = {
  prefix: 'Shown',
  shown: 0,
  object: 'out of',
  size: 0,
  type: 'Object(s)',
  filter: '',
  filterPrefix: ', with filter'
};

export default Total;
